export default __webpack_public_path__ + "assets/images/16546296186c03010bad0147425c97aa.svg";